import { render, staticRenderFns } from "./TodoAddSidebar.vue?vue&type=template&id=6606b158&scoped=true&"
import script from "./TodoAddSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoAddSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoAddSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoAddSidebar.vue?vue&type=style&index=1&id=6606b158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606b158",
  null
  
)

export default component.exports